import React from "react";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const TIMES = [
  { key: "morning", label: "Morning" },
  { key: "noon", label: "Noon" },
  { key: "evening", label: "Evening" },
  { key: "bedtime", label: "Bedtime" },
];

export default function DailyCheckoffChart({ profile, largeText }) {
  // Group meds by time slot
  const byTime = TIMES.map((t) => ({
    ...t,
    meds: (profile.meds || []).filter((m) => (m.times || []).includes(t.key)),
  })).filter((t) => t.meds.length > 0);

  if (byTime.length === 0) return null;

  return (
    <section
      data-testid="daily-checkoff"
      className="bg-white border border-[#E5E2DC] rounded-2xl p-6 sm:p-8 print:break-inside-avoid print:break-before-page"
    >
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-2">
        Weekly medication card · check off each dose
      </div>
      <h3 className={`font-medium text-[#1C2B23] ${largeText ? "text-3xl" : "text-2xl"}`}>
        {profile.name}
      </h3>
      <p className="text-xs text-[#5C6B62] mt-1">
        Week of {new Date().toLocaleDateString()}
      </p>

      <div className="mt-6 space-y-6">
        {byTime.map((t) => (
          <div key={t.key}>
            <div className={`font-semibold text-[#2B5339] uppercase tracking-wide mb-2 ${largeText ? "text-lg" : "text-sm"}`}>
              {t.label}
            </div>
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className={`text-left border border-[#E5E2DC] bg-[#F9F8F6] px-3 py-2 font-medium text-[#5C6B62] ${largeText ? "text-base" : "text-xs"}`}>
                    Medication
                  </th>
                  {DAYS.map((d) => (
                    <th
                      key={d}
                      className={`text-center border border-[#E5E2DC] bg-[#F9F8F6] px-2 py-2 font-medium text-[#5C6B62] ${largeText ? "text-base" : "text-xs"}`}
                    >
                      {d}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {t.meds.map((m) => (
                  <tr key={m.id}>
                    <td className={`border border-[#E5E2DC] px-3 py-3 align-top ${largeText ? "text-lg" : "text-sm"}`}>
                      <div className="font-semibold text-[#1C2B23]">{m.generic_name}</div>
                      <div className="text-[#2B5339] font-medium">{m.strength}</div>
                      {m.directions && (
                        <div className={`text-[#5C6B62] mt-0.5 ${largeText ? "text-sm" : "text-[11px]"}`}>
                          {m.directions}
                        </div>
                      )}
                    </td>
                    {DAYS.map((d) => (
                      <td
                        key={d}
                        className="border border-[#E5E2DC] text-center py-3 align-middle"
                      >
                        <span className="inline-block w-6 h-6 rounded border-2 border-[#5C6B62]" />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </section>
  );
}
